import { resolveWebAssets } from './tools';

import moldAISvg from '@/assets/icons/product_moldai_white.svg';
import moldAISvg2 from '@/assets/icons/moldAISvg2.svg';
import icon_arrow_right from '@/assets/icons/icon_arrow_right.svg';
import icon_arrow_right2 from '@/assets/icons/icon_arrow_right2.svg';
import icon_right_double_arrow from '@/assets/icons/icon_right_double_arrow.svg';
import icon_green_wallet from '@/assets/icons/icon_green_wallet.svg';
import icon_china_flag from '@/assets/icons/icon_china_flag.svg';
import icon_message_notification from '@/assets/icons/icon_message_notification.svg';
import icon_snowflake from '@/assets/icons/icon_snowflake.svg';
import icon_broken_line from '@/assets/icons/icon_broken_line.svg';
import icon_bar_graph from '@/assets/icons/icon_bar_graph.svg';
import icon_account_safe from '@/assets/icons/icon_account_safe.svg';
import icon_right_up_arrow from '@/assets/icons/icon_right_up_arrow.svg';
import icon_envelope from '@/assets/icons/icon_envelope.svg';
import icon_account_info from '@/assets/icons/icon_account_info.svg';
import icon_jump_to from '@/assets/icons/icon_jump_to.svg';
import icon_funnel from '@/assets/icons/icon_funnel.svg';
import icon_right_green from '@/assets/icons/icon_right_green.svg';
import icon_error_red from '@/assets/icons/icon_error_red.svg';
import icon_right_yellow from '@/assets/icons/icon_right_yellow.svg';
import icon_user_head from '@/assets/icons/icon_user_head.svg';
import icon_user_head_active from '@/assets/icons/icon_user_head_active.svg';
import icon_user_login from '@/assets/icons/icon_user_login.svg';
import icon_user_login_active from '@/assets/icons/icon_user_login_active.svg';
import icon_user_logout from '@/assets/icons/icon_user_logout.svg';
import icon_user_logout_active from '@/assets/icons/icon_user_logout_active.svg';
import icon_user_register from '@/assets/icons/icon_user_register.svg';
import icon_user_register_active from '@/assets/icons/icon_user_register_active.svg';
import icon_user_rebuild from '@/assets/icons/icon_user_rebuild.svg';
import icon_user_rebuild_active from '@/assets/icons/icon_user_rebuild_active.svg';
import icon_bilibili from '@/assets/icons/icon_bilibili.svg';
import icon_wxgzh from '@/assets/icons/icon_wxgzh.svg';
import icon_dy from '@/assets/icons/icon_dy.svg';
import icon_wxsph from '@/assets/icons/icon_wxsph.svg';
// 图标
const mainIcon = {
    moldAISvg, // 产品logo
    moldAISvg2,
    icon_arrow_right, // 右箭头
    icon_arrow_right2, // 右箭头2
    icon_right_double_arrow,  // 双右箭头
    icon_green_wallet, // 绿色钱包
    icon_china_flag, // 中国国旗
    icon_message_notification, // 消息通知
    icon_snowflake, // 雪花
    icon_broken_line, // 折线图
    icon_bar_graph, // 柱状图
    icon_account_safe, // 账户安全
    icon_right_up_arrow, // 右上箭头
    icon_envelope, // 信封-联系方式
    icon_account_info,// 基本信息
    icon_jump_to, // 跳转文档
    icon_funnel, // 流水-漏斗
    icon_right_green, // 右绿色箭头
    icon_error_red, // 错误红色箭头
    icon_right_yellow, // 右黄色箭头
    icon_user_head, // 首页用户头像
    icon_user_head_active, // 首页用户头像（激活状态）
    icon_user_logout, // 用户登出
    icon_user_logout_active, // 用户登出（激活状态）
    icon_user_login, // 用户登录
    icon_user_login_active, // 用户登录（激活状态）
    icon_user_register, // 用户注册
    icon_user_register_active, // 用户注册（激活状态）
    icon_user_rebuild, // 用户重建
    icon_user_rebuild_active, // 用户重建（激活状态）
    icon_bilibili, // Bilibili
    icon_wxgzh, // 微信公众号
    icon_dy, // 抖音
    icon_wxsph, // 微信小程序
}

// import home_video_cover from '@/assets/images/home_video_cover.jpg';
// // 图片
// const images = {
//     home_video_cover, // 开屏视频
// }



// web资源
const webAssets = resolveWebAssets({
    home_video_20260618: 'home_video_20260618.mp4', // 开屏视频、
    home_video_cover: 'home_video_cover.jpg', // 开屏视频封面
    bg_sjcj: 'bg_sjcj.svg',   // 世界重建 图片
    bg_sjsc: 'bg_sjsc.svg',   // 世界生成 图片
    bg_xjbz: 'bg_xjbz.svg',   // 细节捕捉 图片
    bg_gmddy: 'bg_gmddy.svg',   // 高密度点云 图片
    bg_jzjm: 'bg_jzjm.svg',   // 精准建模 图片
    bg_gbzcj: 'bg_gbzcj.svg',   // 高保真重建 图片
    bg_scscdhy: 'bg_scscdhy.svg', // 生成式尺度还原 图片
    bg_fzsjsc: 'bg_fzsjsc.svg', // 仿真数据生产 图片
    bg_fzxlyq: 'bg_fzxlyq.svg', // 仿真训练引擎 图片
    bg_jqrbt: 'bg_jqrbt.svg', // 机器人本体 图片
    bg_wlsjsc_after: 'bg_wlsjsc_after.png', // 物理世界生成  生成后
    bg_wlsjsc_before: 'bg_wlsjsc_before.png', // 物理世界生成 生成前
    'Reconstruction_2-v1': 'Reconstruction_2-v1.jpg', // 大规模空间重建 图片
    bg_hyyy_kskjzn: 'bg_hyyy_kskjzn.png', // 开时空间计算 图片
});


import popup_bg from '@/assets/images/popup_bg.webp';
import leftSide_bg from '@/assets/images/leftside_bg.webp';
import home_bg from '@/assets/images/home_bg.webp';
import home_bg_glf from '@/assets/images/home_bg_glf.webp';
import home_title from '@/assets/images/home_title.webp';
import home_imageslist from '@/assets/images/home_imageslist.webp';
import hom_video_20260924 from '@/assets/videos/hom_video_20260924.mp4';
import mobile_3dview from '@/assets/images/mobile_3dview.webp';
const webDev = {
    mobile_3dview, // 移动端3D预览背景图
    popup_bg, // 弹窗背景图
    home_bg_glf, // 动图
    leftSide_bg, // 左侧背景图
    home_bg, // 首页背景图
    home_title, // 首页标题背景图
    home_imageslist, // 首页图片列表背景图
    hom_video_20260924,
}



export default {
    ...mainIcon,
    ...webAssets,
    ...webDev,
}